<template>
  <div class="internal-layout">
    <RouterLink to="/">
      <LogoType />
    </RouterLink>
    <div class="layout-content">
      <slot />
    </div>
  </div>
</template>

<script>
import LogoType from '@/components/logo-type';

export default {
  components: { LogoType },
};
</script>

<style scoped>
.internal-layout {
  background: var(--light-blue);
  color: var(--white);
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: calc(var(--page-padding) + 60px) var(--page-padding)
    var(--page-padding);
  position: relative;

  @media screen and (min-width: 768px) {
    padding: var(--page-padding);
  }
}

.internal-layout.child-view {
  height: auto;
}

.logo-type {
  left: var(--page-padding);
  position: absolute;
  top: var(--page-padding);
}

.layout-content {
  align-items: center;
  display: flex;
  flex-direction: column;
  flex: 1;
  margin: 0 auto;
}
</style>
